import { z } from 'zod';
import { pp_championshipPlayerZodObject } from './pp-championship-player-zod-object';
import { pp_championshipCaddieZodObject } from './pp-championship-caddie-zod-object';
import { pp_onlineEntryZodObject } from './pp-online-entry-creation-zod-object';
import { pp_accreditationFormContactZodObject } from './pp-accreditation-form-contact-zod-object';

export const PP_UpdateInputSchema = z.object({
  callBackUrl: z.string(),
  data: z.union([
    z.object(pp_championshipPlayerZodObject),
    z.object(pp_championshipCaddieZodObject),
  ]),
  bearerToken: z.string(),
  cognitoToken: z.string().optional(),
});

export const PP_CreateAccreditationContactInputSchema = z.object({
  callBackUrl: z.string(),
  data: z.object(pp_accreditationFormContactZodObject),
  bearerToken: z.string(),
});

export const PP_GenericInputSchema = z.object({
  callBackUrl: z.string(),
  bearerToken: z.string(),
});

export const PP_ValuesByIdInputSchema = z.object({
  callBackUrl: z.string(),
  bearerToken: z.string(),
  id: z.string().optional(),
});

export const PP_CreateOnlineEntryInputSchema = z.object({
  callBackUrl: z.string(),
  data: z.object(pp_onlineEntryZodObject),
  bearerToken: z.string(),
});
